import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {environment} from "../../../environments/environment";
import {SetRepairCentreConfigurationDto} from "../../auto-generated-server-dtos/adjuster/configuration/set-repair-centre-configuration-dto";

@Injectable({
  providedIn: 'root'
})
export class SetRepairCentreConfigurationService {

  constructor(private httpClient: HttpClient) { }

  setRepairCentreConfiguration(setRepairCentreConfiguration: SetRepairCentreConfigurationDto) {
    return this.httpClient.put(`${environment.apiServer}/Adjuster/Configuration/SetRepairCentreConfiguration`, { ...setRepairCentreConfiguration });
  }
}
